//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Cpts019',
  props: {
    audioData: {
      type: Object,
      default: {
        name: '',
        url: '',
        playState: false,
        showState: false
      }
    }
  },
  methods: {
    playHandle () {
      this.audioData.playState = !this.audioData.playState
      if (this.audioData.playState) {
        this.audioData.showState = true
        this.audioPlay()
      } else {
        this.audioPause()
      }
    },
    audioPlay () {
      this.$refs.audio.play()
    },
    audioPause () {
      this.$refs.audio.pause()
    },
    audioStop () {
      this.audioData.name = ''
      this.audioData.url = ''
      this.audioData.playState = false
      this.audioData.showState = false
      this.audioLoad()
      this.$parent.audioUrl = ''
    },
    audioLoad () {
      this.$refs.audio.load()
    }
  }
}
